module.exports = __webpack_public_path__ + "img/vartext3ny.fd425580.svg";